
export {
	StripTable,
	normalize,
	IOptions,
	normalize as default,
} from '@lazy-cjk/str-util-normalize';
